class MFREnterAnimation {
    constructor( index, element ) {
        this.index = index;
        this.$element = $( element );

        this.selectors = {
            wrapper: ".shopify-section",
            divider: ".section-divider__top",
            dividerWrapper: ".outer-divider"
        }

        this.borderRadius = 50;
        this.position = this.$element.data( "enter-animation" );
        this.maxPadding = ( $(window).width() <= 639 ) ? 20 : 50;
        this.offset = `-${this.$element.data( "offset" )}`;
        this.scrollID = this.$element.data( "scroll-id" );
        this.wrapperColor = this.$element.data( "wrapper-color" );

        if ( !Shopify.designMode ) {
            this.init();
        }
    }

    init() {
        this.$wrapper = this.$element.closest( this.selectors.wrapper );
        this.$divider = this.$element.find( this.selectors.divider );
        this.$dividerWrapper = this.$element.siblings( this.selectors.dividerWrapper );

        this.moveDividers();
        this.updateAttributes();
        this.addStyling();
        this.initDynamicStyling();
        this.initScrollingEvents();
    }

    addStyling() {
        const marginOffsetArgs = this.position == "top" ? { marginTop: `${this.offset}vh` } :  { marginBottom: `${this.offset}vh` };
        const paddingArgs = this.position == "top" ? { paddingLeft: this.maxPadding, paddingRight: this.maxPadding } : {};
        const borderRadiusArgs = this.position == "top" ? { borderTopLeftRadius: this.borderRadius, borderTopRightRadius: this.borderRadius } : { borderBottomLeftRadius: this.borderRadius, borderBottomRightRadius: this.borderRadius }
        const backgroundArgs = this.position == "top" ? { background: `linear-gradient(180deg, transparent 0, ${this.wrapperColor} ${Math.abs(this.offset)}vh)`} : { background: `linear-gradient(0deg, transparent 10px, ${this.wrapperColor} ${Math.abs(this.offset)}vh)`};
        this.$wrapper.css({
            ...marginOffsetArgs,
            // ...paddingArgs,
            ...backgroundArgs,
            zIndex: "1"
        } )
        if( this.position == "top" ) {
            this.$wrapper.next( ".shopify-section" ).find( "section" ).css( { zIndex: 1 } );
        }
        // this.$element.css( borderRadiusArgs );
    }

    getBorderRadius() {
        return this.position == "top" ? this.$element.css( "borderTopLeftRadius").replace(/[^-\d\.]/g, '') : this.$element.css( "borderBottomLeftRadius").replace(/[^-\d\.]/g, '');
    }

    initScrollingEvents() {
        window.mfrScroll.on('scroll', () => {
            const renderPercentage = this.getPercentage();

            this.updateStyling( renderPercentage );
        });
    }

    updateAttributes() {
        this.$wrapper.attr({
            "data-scroll-section": "",
            "data-scroll-speed": "2"
        });
        this.$element
            .removeAttr( "data-scroll-section" )
            .removeAttr( "data-scroll-section-id" )
            .css({
                pointerEvents: "",
                opacity: ""
            });
        window.mfrScroll.update();
    }

    updateStyling(scrollPercentage) {
        if( this.position == "top" ) {
            const padding = this.maxPadding * scrollPercentage / 100;
            const borderRadius = this.borderRadius * scrollPercentage / 100;
            let renderPadding, renderBorderRadius;
            
            if( padding <= 0 ) {
                renderPadding = Math.max( 0, padding.toFixed(0) );
                renderBorderRadius = Math.max( 0, borderRadius.toFixed(0) );
            }
            else if( padding > 0 ) {
                renderPadding = Math.min( this.maxPadding, padding.toFixed(0) );
                renderBorderRadius = Math.min( this.borderRadius, borderRadius.toFixed(0) );
            }
            
            this.$wrapper.css({
                paddingLeft: `${renderPadding}px`,
                paddingRight: `${renderPadding}px`
            });

            this.$element.css( {
                borderTopLeftRadius: `${renderBorderRadius}px`,
                borderTopRightRadius: `${renderBorderRadius}px`
            } );
        }
        else if( this.position == "bottom" ) {
            scrollPercentage = 100 - scrollPercentage;
            const padding = this.maxPadding * scrollPercentage / 100;
            const borderRadius = this.borderRadius * scrollPercentage / 100;
            let renderPadding, renderBorderRadius;
            
            if( padding <= 0 ) {
                renderPadding = Math.max( 0, padding.toFixed(0) );
                renderBorderRadius = Math.max( 0, borderRadius.toFixed(0) );
            }
            else if( padding > 0 ) {
                renderPadding = Math.min( this.maxPadding, padding.toFixed(0) );
                renderBorderRadius = Math.min( this.borderRadius, borderRadius.toFixed(0) );
            }
            
            this.$wrapper.css({
                paddingLeft: `${renderPadding}px`,
                paddingRight: `${renderPadding}px`
            });

            this.$element.css( {
                borderBottomLeftRadius: `${renderBorderRadius}px`,
                borderBottomRightRadius: `${renderBorderRadius}px`
            } );
        }
    }

    initDynamicStyling() {
        const renderPercentage = this.getPercentage();

        this.updateStyling( renderPercentage );
    }

    getPercentage() {
        const viewportHeight = $( window ).innerHeight();
        const element = this.$element;
        const startTrigger = ( this.position == "top" ) ? 50 : 80;
        const endTrigger = ( this.position == "top" ) ? 20 : 50;
        const elementTopPosition = ( this.position == "top" ) ? element.get(0).getBoundingClientRect().top : element.get(0).getBoundingClientRect().top + element.height();
        const topTrigger = viewportHeight * (endTrigger / 100);
        const bottomTrigger = viewportHeight * (startTrigger / 100);
        const percentage = ((elementTopPosition - topTrigger) / (bottomTrigger - topTrigger )) * 100;
        let renderPercentage;

        if( percentage >= 100 )
            renderPercentage = 100;
        else if ( percentage <= 0 )
            renderPercentage = 0;
        else
            renderPercentage = percentage;

        return renderPercentage;
    }

    moveDividers() {
        if( this.position == "top" )
            this.$dividerWrapper.css( {
                position: "relative",
                width: `calc( 100% - ${this.maxPadding}px )`,
                margin: `0 auto`
            } );

        this.$divider.appendTo( this.$dividerWrapper );
    }
}